/**
 * Sesiones web: ya no se sincronizan con Firebase Realtime Database.
 * El control de sesión queda en tabla `sesiones` + JWT (middleware en API).
 */
export default {
    state:{
      sesiones:{
        web:[]
      }
    },
    mutations: {
      setSesiones(state,sesiones){
        state.sesiones.web=sesiones;
      },
      setSession(state, payload) {
        state.sesion = payload;
      },
    },
    actions: {
      Actualizar_Sesiones(context){
        context.commit('setSesiones', []);
      },
    },
    getters: {
      getSesiones(state){
        return state.sesiones.web;
      },
      getTotalSesiones(state){
        return state.sesiones.web.length;
      },
    },

}



// WEBPACK FOOTER //
// ./src/modules/sesiones.js